module.exports = __webpack_public_path__ + "img/lc01.7ff7661e.png";